import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { Modal, WhiteButton, Button, OrderProductImages } from 'components';
import { PortalPageSection, ButtonsSection } from 'components/PortalStructure';
import { IModalAction } from 'models/modal';
import { IOrderListItem } from 'models/orders/order';
import { PortalFieldLabel } from 'components/FormControls';
import { PortalTextArea } from 'components/Common/PortalTextArea';

interface IProps {
	item: IOrderListItem;

	/* functions props */
	rejectOrder?: (shopOrderId: string, orderId: string, note: string) => void;
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
}

interface IState {
	note: string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class RejectOrder extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.handleOnRejectOrderClick = this.handleOnRejectOrderClick.bind(this);
		this.handleOnCloseModalClick = this.handleOnCloseModalClick.bind(this);
		this.handleOnNoteValueChange = this.handleOnNoteValueChange.bind(this);

		this.state = {
			note: '',
		};
	}

	private handleOnRejectOrderClick() {
		this.props.rejectOrder(this.props.item.id, this.props.item.orderId, this.state.note);
	}

	private handleOnCloseModalClick() {
		this.props.closeModal();
	}

	private handleOnNoteValueChange(e: any) {
		if (e) {
			this.setState({ note: e.target.value });
		}
	}

	public render() {
		const { t, item } = this.props;
		const { note } = this.state;

		return (
			<div className="rejectOrder">
				<Modal
					title={t('Orders_RejectOrder_Title')}
					closeModal={this.handleOnCloseModalClick}
					showHeaderCloseButton={true}
				>
					<div className="rejectOrderWrapper">
						<PortalPageSection>
							<div className="row">
								<div className="col-md-12">
									{t('Orders_RejectOrder_Label_OrderNo')} {item.id}
								</div>
							</div>
							<div className="row">
								<div className="col-md-12">
									<OrderProductImages images={item.productImages} />
								</div>
							</div>
							<div className="row">
								<div className="col-md-12">
									<PortalFieldLabel name="message" text={t('Orders_RejectOrder_Label_Message')} />
									<PortalTextArea rows={5} onChangeAction={this.handleOnNoteValueChange} value={note} />
								</div>
							</div>
						</PortalPageSection>
						<ButtonsSection>
							<div className="row">
								<div className="col-sm-6">
									<div className="clear" />
								</div>
								<div className="col-sm-6">
									<div className="floatRight">
										<WhiteButton onClick={this.handleOnCloseModalClick}>{t('BSPortal_Common_Cancel')}</WhiteButton>
										<Button onClick={this.handleOnRejectOrderClick}>{t('BSPortal_Common_Send')}</Button>
										<div className="clear" />
									</div>
									<div className="clear" />
								</div>
							</div>
						</ButtonsSection>
					</div>
				</Modal>
			</div>
		);
	}
}
export { RejectOrder };
